import { Checkbox, Label } from "@ui/shad"
import { cn } from "@ui/utils"

interface CheckboxInputProps {
  id: string
  checked: boolean
  onChange: (checked: boolean) => void
  label?: string
  error?: boolean
  disabled?: boolean
  className?: string
  size?: "default" | "lg" | "xl"
}

export function CheckboxInput({
  checked,
  onChange,
  label,
  error = false,
  disabled = false,
  id,
  className,
  size = "default",
}: CheckboxInputProps) {
  return (
    <div className="space-y-1">
      <div className={cn("flex items-center space-x-2", className)}>
        <Checkbox id={id} checked={checked} onCheckedChange={onChange} disabled={disabled} size={size} />
        {label && (
          <Label
            htmlFor={id}
            className={cn("cursor-pointer text-sm leading-none font-medium", error && "text-destructive")}
          >
            {label}
          </Label>
        )}
      </div>
    </div>
  )
}
